// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { ResourceOriginRepository } from '../../../domain/repository';
import { ResourceOriginEntity } from '../../../domain/entities/resource-origin-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class ResourceOriginDummyRepository implements ResourceOriginRepository {
  // eslint-disable-next-line class-methods-use-this
  execute(): Promise<Array<ResourceOriginEntity>> {
    return Promise.resolve(fixtures);
  }
}
